import { render, staticRenderFns } from "./IconLinkSlider.vue?vue&type=template&id=7be56f50&scoped=true&"
import script from "./IconLinkSlider.vue?vue&type=script&lang=js&"
export * from "./IconLinkSlider.vue?vue&type=script&lang=js&"
import style0 from "./IconLinkSlider.vue?vue&type=style&index=0&id=7be56f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be56f50",
  null
  
)

export default component.exports